var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "data-title" }, [
            _vm._m(0),
            _c("div", { staticClass: "title-btn" }, [
              _c(
                "div",
                { staticClass: "title-btn-item", on: { click: _vm.openAdiog } },
                [
                  _c("i", { staticClass: "el-icon-plus" }),
                  _c("div", { staticClass: "btn-l" }, [_vm._v("新增热更新")]),
                ]
              ),
            ]),
          ]),
          _c("lb-table", {
            attrs: {
              column: _vm.column,
              data: _vm.tableList,
              pagination: "",
              total: _vm.page.totalNum,
              layout: "total, sizes, prev, pager, next, jumper",
              "page-sizes": [5, 10, 20, 30, 50],
              "current-page": _vm.page.currentPage,
              "page-size": _vm.page.pageSize,
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.page, "currentPage", $event)
              },
              "size-change": _vm.handleSizeChange,
              "p-current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "update-app",
          attrs: {
            visible: _vm.dialogFormVisible,
            "append-to-body": true,
            title: "新增热更新",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "elForm",
              attrs: { model: _vm.form, rules: _vm.rules, size: "small" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "100px",
                    label: "版本号",
                    prop: "version",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "360px" },
                    attrs: {
                      maxlength: "6",
                      placeholder: "请输入版本号,例如：1.0.01",
                      size: "small",
                    },
                    model: {
                      value: _vm.form.version,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "version", $$v)
                      },
                      expression: "form.version",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "upload-file-con",
                  attrs: {
                    "label-width": "100px",
                    label: "热更包",
                    prop: "wgtUrl",
                  },
                },
                [
                  _c("upload-file", {
                    attrs: {
                      limit: 1,
                      suffix: ".wgt",
                      "file-list": _vm.fileList,
                    },
                    on: { getUrl: _vm.getUrl },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    "label-width": "100px",
                    label: "更新内容",
                    prop: "updateTips",
                  },
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "360px" },
                    attrs: {
                      maxlength: "128",
                      rows: 4,
                      "show-word-limit": "",
                      type: "textarea",
                      placeholder: "请输入更新内容",
                    },
                    model: {
                      value: _vm.form.updateTips,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "updateTips", $$v)
                      },
                      expression: "form.updateTips",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.btnloading },
                  on: { click: _vm.updateOk },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticStyle: { display: "flex", height: "32px" } }, [
      _c("div", { staticClass: "title-line" }),
      _c("div", { staticClass: "title-name" }, [_vm._v("更新记录")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }